import React, { useEffect, useState, useRef } from "react";
import productAPI from "../../api/productApi";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

function SearchCanvas({ isOpen, searchText, setSearchText, onClose }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 100);
    } else {
      setProducts([]);
      setSearchText("");
    }
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose]);

  useEffect(() => {
    if (!searchText) { setProducts([]); return; }
    const delay = setTimeout(() => fetchProducts(1, searchText), 400);
    return () => clearTimeout(delay);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, keyword) => {
    setLoading(true);
    try {
      const res = await productAPI.listing({ page: pageNum, limit: 6, keyword });
      if (res.code === 200) {
        setProducts((prev) =>
          pageNum === 1 ? res.data.products : [...prev, ...res.data.products]
        );
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fs-search-overlay">

      {/* Top right X */}
      <button className="fs-search-close" onClick={onClose}>
        <X size={20} />
      </button>

      {/* Center content */}
      <div className="fs-search-center">
        <p className="fs-search-label">SEARCH PRODUCTS</p>

        <div className="fs-search-input-wrap">
          <input
            ref={inputRef}
            type="text"
            className="fs-search-input"
            placeholder="What are you looking for?"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        {/* Results */}
        {loading && <p className="fs-search-status">Searching...</p>}

        {!loading && searchText && products.length === 0 && (
          <p className="fs-search-status">No results for "<b>{searchText}</b>"</p>
        )}

       {!loading && products.length > 0 && (
  <div className="fs-search-results">
    {products.map((product) => {
      const image =
        product?.thumbnail || product?.images?.[0];

      const price =
        product?.variants?.[0]?.price || product?.price;

      const mrp =
        product?.variants?.[0]?.mrp || product?.mrp;

      return (
        <Link
          to={`/shop/${product.slug}`}
          className="fs-search-item"
          key={product._id}
          onClick={onClose}
        >
          <div className="fs-search-product-image">
            <img
              src={image}
              alt={product.title}
            />
          </div>

          <div className="fs-search-product-info">
            <span className="fs-search-product-category">
              {product?.category || "BICYCLE"}
            </span>

            <p className="fs-search-item-title">
              {product.title}
            </p>

            <div className="fs-search-price-row">
              <span className="fs-search-item-price">
                ₹{price}
              </span>

              {mrp && Number(mrp) > Number(price) && (
                <span className="fs-search-mrp">
                  ₹{mrp}
                </span>
              )}
            </div>
          </div>

          <span className="fs-search-arrow">
            →
          </span>
        </Link>
      );
    })}
  </div>
)}
      </div>
    </div>
  );
}

export default SearchCanvas;